import { Component } from '@angular/core';
import { CommonService, JwtService, UserService } from '@core/services';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  template: '<router-outlet *ngIf="loaded"></router-outlet>'
})
export class AppComponent {
  
  loaded = false;

  constructor(private userService: UserService,
              private commonService: CommonService,
              private jwtService: JwtService) {
  }

  ngOnInit(): void {
    // this.userService.getUserData()
    // .subscribe((user) => {
    // })

    if(this.jwtService.getTocken()) {
      this.loadUser();
    } else {
      this.setAppLoaded();
    }
  }

  private setAppLoaded() {
    this.loaded = true;
    this.commonService.setAppLoaded(true);
  }

  private loadUser() {
    this.userService.loadUserData()
    .pipe(take(1))
    .subscribe((data: any) => {
      this.userService.setUserData(data);
      this.setAppLoaded();
    }, err => {
      this.setAppLoaded();
    })
  }

}
